import React from 'react'
import PropTypes from 'prop-types'
import styles, { itemStyle } from './styles'
import shareItems from './config'
import { sendGoogleTagEvent } from '../../utils/google-tag-manager-helpers'

const buildShareItem = ({ item, title, url }) => {
  const Icon = item.icon
  let href = item.url.replace('TITLE_REPLACE', encodeURIComponent(title))
  href = href.replace('URL_REPLACE', encodeURIComponent(url))

  const handleClick = (event, link) => {
    event.preventDefault()
    sendGoogleTagEvent('share', { item: item.name, link })
    window.open(link, '', 'height=500,width=600')
  }

  const linkProps = {
    href,
    className: item.name,
    onClick: item.popup ? (event => handleClick(event, href)) : null,
  }

  return (
    <li key={item.name}>
      <a {...linkProps}>
        <Icon
          width={item.width}
          height={item.height}
          title={item.title}
        />
      </a>
      <style jsx>{itemStyle}</style>
    </li>
  )
}

const SocialShares = ({ title, url }) => (
  <div className="SocialShares">
    <h2>Share</h2>
    <ul>
      { shareItems.map(item => buildShareItem({ item, title, url })) }
    </ul>
    <style jsx>{styles}</style>
  </div>
)

SocialShares.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

buildShareItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    popup: PropTypes.string.isRequired,
  }).isRequired,
}

export default SocialShares
